export default {
    init: function () {
        // Get the back-to-top button
        const backToTop = document.getElementById('back-to-top');

        // Exit early if the back-to-top element doesn't exist
        if (!backToTop) return;

        // Add scroll event listener
        window.addEventListener('scroll', function() {
            const distanceY = window.scrollY || document.documentElement.scrollTop;
            const shrinkOn = 3;

            if (distanceY > shrinkOn) {
                backToTop.classList.add('show');
            } else {
                backToTop.classList.remove('show');
            }
        });

        // Add click event for scrolling elements
        const scrollTriggers = document.querySelectorAll('[data-toggle="scroll"]');
        scrollTriggers.forEach(trigger => {
            trigger.addEventListener('click', function(e) {
                e.preventDefault();

                let offset = -70;
                const windowSize = window.innerWidth;

                if (windowSize < 991.98) {
                    offset = -50;
                }

                // Use the hash from the clicked element
                const hash = this.getAttribute('href') || this.hash;
                if (hash) {
                    nativeScrollTo(hash, 300, offset);
                }

                return false;
            });
        });

        // Add click event for back-to-top button
        backToTop.addEventListener('click', function(e) {
            e.preventDefault();

            // Smooth scroll to top
            smoothScrollToTop(300);

            return false;
        });
    }
};

// Smooth scrolling to an element
function nativeScrollTo(selector, duration = 300, offset = 0) {
    const target = document.querySelector(selector);
    if (!target) {
        console.warn(`Element not found: ${selector}`);
        return;
    }

    const targetPosition = target.getBoundingClientRect().top + window.scrollY + offset;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
}

// Smooth scroll to top function
function smoothScrollToTop(duration) {
    const startPosition = window.scrollY;
    const distance = -startPosition;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
}
